import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { SealCheck, LockSimple } from "@phosphor-icons/react";
import { adminApi, getErrorMessage } from "@/lib/api";
import { Card, Pill, btnPrimary } from "./ui";

const fmt = (iso) => new Date(iso).toLocaleString("en-AU", { timeZone: "Australia/Brisbane", dateStyle: "medium", timeStyle: "short" });

export function AuthorisePanel({ rep, onDone }) {
  const [note, setNote] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!rep) return null;
  const submit = async () => {
    setBusy(true);
    try { onDone((await adminApi.post("/admin/wi/validation/approve", { note, confirm })).data); toast.success("Historical database validated"); }
    catch (e) { toast.error(getErrorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Card title="Validation sign-off" icon={SealCheck} testId="wi-authorise-panel">
      <div className="flex items-center gap-2 mb-3 text-xs text-neutral-400">
        <LockSimple size={14} className="text-amber-400" />
        AI assessment of new claims: <Pill tone={rep.ai_assessment_enabled ? "green" : "amber"} testId="wi-ai-assessment-state">{rep.ai_assessment_enabled ? "On · suggestions only" : "Not active"}</Pill>
      </div>
      {rep.validated ? (
        <div className="text-sm text-neutral-300 space-y-1" data-testid="wi-validated-info">
          <p className="text-[#73bf44] font-semibold">Historical database validated {fmt(rep.validated_at)}</p>
          {rep.validation_note && <p className="text-neutral-400">“{rep.validation_note}”</p>}
          <p className="text-xs text-neutral-500">New-claim assessment is switched on separately, in suggestions-only mode.</p>
          <Link to="/admin/warranty-intel/assessments" className="inline-block text-xs text-[#73bf44] hover:underline pt-1" data-testid="wi-goto-assessments">Go to AI Assessments →</Link>
        </div>
      ) : (
        <div className="space-y-3">
          <p className="text-xs text-neutral-500 leading-relaxed">
            Review the report and the exceptions first. Signing off records your approval of the historical pricing database. It does not
            switch on AI assessment, approvals, emails or any Monday.com changes.
          </p>
          <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={1000} data-testid="wi-validation-note"
            placeholder="Sign-off note, e.g. Reviewed exceptions; unresolved items documented."
            className="w-full bg-black/40 border border-neutral-800 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#73bf44] placeholder:text-neutral-600" />
          <label className="flex items-start gap-2 text-xs text-neutral-300 cursor-pointer">
            <input type="checkbox" checked={confirm} onChange={(e) => setConfirm(e.target.checked)} className="mt-0.5 accent-[#73bf44]" data-testid="wi-validation-confirm" />
            I've reviewed the validation report and accept the documented exceptions.
          </label>
          <button className={btnPrimary} disabled={!rep.ready_for_validation || !confirm || busy} onClick={submit} data-testid="wi-validate-btn">
            <SealCheck size={15} weight="fill" /> Validate historical database
          </button>
          {!rep.ready_for_validation && <p className="text-[0.7rem] text-neutral-600">Available once the import has finished.</p>}
        </div>
      )}
    </Card>
  );
}
